// // // import React, { useState, useEffect } from 'react';
// // // import { Select, Button, Form, Table, message, Tooltip, Input, Popconfirm, Checkbox, Card } from 'antd';
// // // import { CheckCircleFilled, ExclamationCircleFilled, DeleteOutlined } from '@ant-design/icons';
// // // import { supabase } from '@/lib/supabase';

// // // const { Option } = Select;

// // // interface ForeignKey {
// // //   source_table?: string;
// // //   source_column?: string;
// // //   display_column?: string;
// // // }

// // // interface SemanticType {
// // //   role: string;
// // //   sub_type: string;
// // //   default_aggregation: string;
// // //   order: string[];
// // // }

// // // interface MetadataItem {
// // //   key: string;
// // //   type: string;
// // //   display_name: string;
// // //   foreign_key?: ForeignKey;
// // //   semantic_type: SemanticType;
// // //   is_searchable: boolean;
// // //   is_displayable: boolean;
// // // }

// // // interface Column {
// // //   key: string;
// // //   type: string;
// // //   display_name: string;
// // //   foreign_key?: ForeignKey;
// // //   potential_fk?: ForeignKey;
// // // }

// // // interface MetadataProps {
// // //   entityType: string;
// // //   metadataInit?: MetadataItem[];
// // //   fetchConfigs: () => void;
// // //   entitySchema?: string; // Added entitySchema to props
// // // }

// // // const toTitleCase = (str: string) => {
// // //   // Split snake_case into words
// // //   const words = str
// // //     .split('_')
// // //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

// // //   // If the result is exactly two words and the second word is "Id", remove "Id"
// // //   if (words.length === 2 && words[1] === 'Id') {
// // //     return words[0];
// // //   }

// // //   // If the string is just "id", return " MOE "Id"
// // //   if (str.toLowerCase() === 'id') {
// // //     return 'Id';
// // //   }

// // //   // Otherwise, join words with a space
// // //   return words.join(' ');
// // // };

// // // const Metadata: React.FC<MetadataProps> = ({ entityType, metadataInit, fetchConfigs, entitySchema }) => {
// // //   const [columns, setColumns] = useState<Column[]>([]);
// // //   const [metadata, setMetadata] = useState<MetadataItem[]>([]);
// // //   const [loading, setLoading] = useState<boolean>(true);
// // //   const [form] = Form.useForm();
// // //   const [formValues, setFormValues] = useState<any>({});

// // //   const fieldOptions = {
// // //     semantic_type_role_options: [
// // //       { value: 'dimension', color: '#E6F0FA' }, // Light blue
// // //       { value: 'measure', color: '#B3D4FF' }, // Slightly darker blue
// // //     ],
// // //     semantic_type_sub_type_options: [
// // //       { value: 'quantitative', color: '#E6FFE6' }, // Light green
// // //       { value: 'temporal', color: '#CCFFCC' }, // Slightly darker green
// // //       { value: 'nominal', color: '#B3FFB3' }, // Medium green
// // //       { value: 'ordinal', color: '#99FF99' }, // Darker green
// // //       { value: 'geojson', color: '#80FF80' }, // Darkest green
// // //     ],
// // //     semantic_type_default_aggregation_options: [
// // //       { value: 'sum', color: '#F2E6FA' }, // Light purple
// // //       { value: 'avg', color: '#E5CCFF' }, // Slightly darker purple
// // //       { value: 'min', color: '#D8B3FF' }, // Medium purple
// // //       { value: 'max', color: '#CC99FF' }, // Darker purple
// // //       { value: 'count', color: '#BF80FF' }, // Darkest purple
// // //       { value: 'count_distinct', color: '#B266FF' }, // Even darker purple
// // //     ],
// // //   };

// // //   useEffect(() => {
// // //     async function fetchData() {
// // //       try {
// // //         if (!entityType) return;
// // //         setLoading(true);

// // //         // Fetch metadata from y_view_config
// // //         const { data: configData, error: configError } = await supabase
// // //           .from('y_view_config')
// // //           .select('metadata')
// // //           .eq('entity_type', entityType)
// // //           .eq('entity_schema', entitySchema || 'public') // Use entitySchema or default to 'public'
// // //           .single();

// // //         if (configError && configError.code !== 'PGRST116') {
// // //           throw configError;
// // //         }

// // //         const existingMetadata = configData?.metadata || metadataInit || [];

// // //         // Fetch columns
// // //         // const columnsResponse = await supabase.rpc('core_config_get_entity_columns', { tablename: entityType });
// // //         const columnsResponse = await supabase.rpc('core_config_get_entity_columns', {
// // //           p_tablename: entityType,
// // //           p_schema_name: entitySchema || 'public' // Use entitySchema or default to 'public'
// // //         });
// // //         console.log('Data from get_domain_columns_v2-MD:', columnsResponse,entityType, entitySchema);

// // //         if (columnsResponse.error) throw columnsResponse.error;

// // //         setColumns(columnsResponse.data || []);

// // //         const initialValues = columnsResponse?.data?.reduce((acc: any, col: Column) => {
// // //           const metadataEntry = existingMetadata.find((item: MetadataItem) => item.key === col.key) || {};
// // //           const isNumeric = col.type === 'numeric';
// // //           const isTimestamp = col.type === 'timestamp with time zone';

// // //           acc[col.key] = {
// // //             type: metadataEntry.type || col.type,
// // //             display_name: toTitleCase(metadataEntry.display_name || col.display_name),
// // //             source_table: metadataEntry.foreign_key?.source_table || col.foreign_key?.source_table || col.potential_fk?.source_table || '',
// // //             source_column: metadataEntry.foreign_key?.source_column || col.foreign_key?.source_column || col.potential_fk?.source_column || '',
// // //             display_column: metadataEntry.foreign_key?.display_column || col.foreign_key?.display_column || col.potential_fk?.display_column || '',
// // //             semantic_type_role: metadataEntry.semantic_type?.role || (isNumeric ? 'measure' : isTimestamp ? 'dimension' : 'dimension'),
// // //             semantic_type_sub_type: metadataEntry.semantic_type?.sub_type || (isNumeric ? 'quantitative' : isTimestamp ? 'temporal' : 'nominal'),
// // //             semantic_type_default_aggregation: metadataEntry.semantic_type?.default_aggregation || (isNumeric ? 'sum' : 'count'),
// // //             is_searchable: metadataEntry.is_searchable ?? true,
// // //             is_displayable: metadataEntry.is_displayable ?? true,
// // //             order: metadataEntry.semantic_type?.order?.join(', ') || '',
// // //           };
// // //           return acc;
// // //         }, {});

// // //         form.setFieldsValue(initialValues);
// // //         setFormValues(initialValues);
// // //         setMetadata(existingMetadata);
// // //       } catch (error) {
// // //         setColumns([]);
// // //         form.setFieldsValue({});
// // //         setFormValues({});
// // //         setMetadata([]);
// // //         console.error('Error fetching columns or metadata:', error.message);
// // //         message.error('Failed to load data: ' + error.message);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     }

// // //     if (entityType) {
// // //       fetchData();
// // //     }
// // //   }, [entityType, metadataInit, form, entitySchema]); // Added entitySchema to dependencies

// // //   // Update formValues when form changes
// // //   const handleValuesChange = (changedValues: any, allValues: any) => {
// // //     setFormValues(allValues);
// // //   };

// // //   // const onFinish = async (values: any) => {
// // //   //   try {
// // //   //     const metadataData = Object.entries(values).map(([key, field]: [string, any]) => {
// // //   //       const foreignKey: ForeignKey = {
// // //   //         source_table: field.source_table?.trim() || undefined,
// // //   //         source_column: field.source_column?.trim() || undefined,
// // //   //         display_column: field.display_column?.trim() || undefined,
// // //   //       };

// // //   //       return {
// // //   //         key,
// // //   //         type: field.type,
// // //   //         display_name: field.display_name,
// // //   //         foreign_key: Object.values(foreignKey).every(v => v === undefined) ? undefined : foreignKey,
// // //   //         semantic_type: {
// // //   //           role: field.semantic_type_role,
// // //   //           sub_type: field.semantic_type_sub_type,
// // //   //           default_aggregation: field.semantic_type_default_aggregation || (field.semantic_type_role === 'measure' ? 'sum' : 'count'),
// // //   //           order: field.semantic_type_sub_type === 'ordinal' ? (field.order ? field.order.split(',').map((item: string) => item.trim()).filter(Boolean) : []) : [],
// // //   //         },
// // //   //         is_searchable: field.is_searchable,
// // //   //         is_displayable: field.is_displayable,
// // //   //       };
// // //   //     });

// // //   //     const { error } = await supabase
// // //   //       .from('y_view_config')
// // //   //       .upsert(
// // //   //         {
// // //   //           entity_type: entityType,
// // //   //           entity_schema: entitySchema || 'public', // Use entitySchema or default to 'public'
// // //   //           metadata: metadataData.filter(item => item.foreign_key || item.type !== item.key || item.semantic_type.role !== 'dimension' || item.is_searchable || item.is_displayable),
// // //   //         },
// // //   //         {
// // //   //           onConflict: 'entity_type',
// // //   //           ignoreDuplicates: false,
// // //   //         }
// // //   //       );

// // //   //     if (error) {
// // //   //       console.error('Supabase error:', error);
// // //   //       throw new Error(`Error updating metadata: ${error.message}`);
// // //   //     }

// // //   //     message.success('Metadata configuration saved successfully!');
// // //   //     setMetadata(metadataData);
// // //   //     fetchConfigs();
// // //   //   } catch (error) {
// // //   //     console.error('Error in onFinish:', error);
// // //   //     message.error('Failed to save metadata configuration: ' + error.message);
// // //   //   }
// // //   // };

// // //    const onFinish = async (values: any) => {
// // //     try {
// // //       // ... (your existing logic for metadataData, foreignKey, semantic_type etc.) ...

// // //       const metadataData = Object.entries(values).map(([key, field]: [string, any]) => {
// // //         const foreignKey: ForeignKey = {
// // //           source_table: field.source_table?.trim() || undefined,
// // //           source_column: field.source_column?.trim() || undefined,
// // //           display_column: field.display_column?.trim() || undefined,
// // //         };

// // //         return {
// // //           key,
// // //           type: field.type,
// // //           display_name: field.display_name,
// // //           // Only include foreign_key if any of its sub-fields are not undefined/empty
// // //           foreign_key: Object.values(foreignKey).some(v => v !== undefined && v !== '') ? foreignKey : undefined,
// // //           semantic_type: {
// // //             role: field.semantic_type_role,
// // //             sub_type: field.semantic_type_sub_type,
// // //             default_aggregation: field.semantic_type_default_aggregation || (field.semantic_type_role === 'measure' ? 'sum' : 'count'),
// // //             order: field.semantic_type_sub_type === 'ordinal' ? (field.order ? field.order.split(',').map((item: string) => item.trim()).filter(Boolean) : []) : [],
// // //           },
// // //           is_searchable: field.is_searchable,
// // //           is_displayable: field.is_displayable,
// // //         };
// // //       });

// // //       // Prepare the upsert payload
// // //       const upsertPayload: any = {
// // //         entity_type: entityType,
// // //         entity_schema: entitySchema || 'public', // Ensure this is correctly passed
// // //         metadata: metadataData.filter(item => {
// // //           // Keep items if they have a foreign_key, or if any of their other properties
// // //           // deviate from their default/initial state (to minimize payload size if desired).
// // //           // For simplicity and safety, you might just send all configured metadata.
// // //           // This filter logic needs to be robust if you want to only save "changed" fields.
// // //           // For now, let's assume you want to save the entire list of configured metadata.
// // //           return true; // Always include all processed metadata items
// // //         }),
// // //       };

// // //       // CRITICAL: Include the 'id' of the existing record if it's an update
// // //       // The data state variable holds the fetched record from the useEffect.
// // //       if (data && data.id) {
// // //         upsertPayload.id = data.id;
// // //       }

// // //       const { error, data: savedRecords } = await supabase
// // //         .from('y_view_config')
// // //         .upsert(
// // //           upsertPayload,
// // //           {
// // //             // --- THE FIX: Change onConflict to match the composite unique constraint ---
// // //             onConflict: 'entity_type,entity_schema',
// // //             ignoreDuplicates: false, // Keep this as false
// // //           }
// // //         );

// // //       if (error) {
// // //         console.error('Supabase error:', error);
// // //         // Provide more specific error message for unique constraint violation
// // //         if (error.code === '23505') { // PostgreSQL unique violation error code
// // //             throw new Error('A metadata configuration for this Entity Type and Schema already exists. Please modify the existing entry.');
// // //         }
// // //         throw new Error(`Error updating metadata: ${error.message}`);
// // //       }

// // //       message.success('Metadata configuration saved successfully!');
// // //       setMetadata(metadataData);
// // //       // If it was a new insert, update the local 'data' state with the newly created record
// // //       // This is crucial so that subsequent saves on the same form instance become updates.
// // //       if (!data && savedRecords && savedRecords.length > 0) {
// // //           setData(savedRecords[0]); // Assuming upsert returns an array of records
// // //       }
// // //       fetchConfigs(); // Call external fetchConfigs to refresh parent component data if needed
// // //     } catch (error: any) { // Use 'any' for error to access message property safely
// // //       console.error('Error in onFinish:', error);
// // //       message.error('Failed to save metadata configuration: ' + error.message);
// // //     }
// // //   };

// // //   const handleDelete = (record: MetadataItem) => {
// // //     const updatedMetadata = metadata.filter(item => item.key !== record.key);
// // //     setMetadata(updatedMetadata);

// // //     const updatedValues = { ...form.getFieldsValue() };
// // //     delete updatedValues[record.key];
// // //     form.setFieldsValue(updatedValues);
// // //     setFormValues(updatedValues);
// // //   };

// // //   if (loading) return <div>Loading...</div>;

// // //   const dataTypeOptions = [
// // //     'bigint', 'integer', 'smallint', 'numeric', 'real', 'double precision',
// // //     'text', 'varchar', 'char', 'date', 'timestamp', 'timestamp with time zone',
// // //     'boolean', 'uuid', 'json', 'jsonb', 'array',
// // //   ];

// // //   // Helper to get option color
// // //   const getOptionColor = (field: string, value: string) => {
// // //     const options = fieldOptions[`${field}_options` as keyof typeof fieldOptions];
// // //     return options.find((opt: any) => opt.value === value)?.color || '#FFFFFF';
// // //   };

// // //   const columnsDef = [
// // //     {
// // //       title: 'Field Names',
// // //       dataIndex: 'key',
// // //       key: 'key',
// // //       render: (text: string, record: Column) => {
// // //         const metadataTemp = metadata?.reduce((acc: any, item) => {
// // //           acc[item.key] = item;
// // //           return acc;
// // //         }, {});
// // //         const isUpdated = metadataTemp && metadataTemp[record?.key]?.type === record?.type;
// // //         const isNew = metadataTemp && (!metadataTemp[record?.key] || metadataTemp[record?.key]?.type !== record?.type);
// // //         const rowStyle: React.CSSProperties = isUpdated ? { backgroundColor: 'lightgreen' } : isNew ? { backgroundColor: 'lightpink' } : {};
// // //         return (
// // //           <span style={rowStyle}>
// // //             {text} ({record?.type})
// // //           </span>
// // //         );
// // //       },
// // //     },
// // //     {
// // //       title: 'Display Name',
// // //       dataIndex: ['display_name'],
// // //       key: 'display_name',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'display_name']} noStyle>
// // //           <Input
// // //             placeholder="Display Name"
// // //             defaultValue={metadata?.find(item => item.key === record.key)?.display_name || record?.display_name || ''}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Data Type',
// // //       dataIndex: ['type'],
// // //       key: 'type',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'type']} noStyle>
// // //           <Select
// // //             style={{ width: '100%' }}
// // //             defaultValue={metadata?.find(item => item.key === record.key)?.type || record?.type}
// // //             onChange={(value) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const isNumeric = value === 'numeric';
// // //               const isTimestamp = value === 'timestamp with time zone';
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   type: value,
// // //                   semantic_type_role: isNumeric ? 'measure' : isTimestamp ? 'dimension' : 'dimension',
// // //                   semantic_type_sub_type: isNumeric ? 'quantitative' : isTimestamp ? 'temporal' : 'nominal',
// // //                   semantic_type_default_aggregation: isNumeric ? 'sum' : 'count',
// // //                   order: '',
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           >
// // //             {dataTypeOptions?.map(type => (
// // //               <Option key={type} value={type}>{type}</Option>
// // //             ))}
// // //           </Select>
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     // {
// // //     //   title: 'Semantic Type Role',
// // //     //   dataIndex: ['semantic_type_role'],
// // //     //   key: 'semantic_type_role',
// // //     //   render: (_: any, record: Column) => {
// // //     //     const currentValue = formValues[record.key]?.semantic_type_role ||
// // //     //       metadata?.find(item => item.key === record.key)?.semantic_type?.role ||
// // //     //       (record.type === 'numeric' ? 'measure' : record.type === 'timestamp with time zone' ? 'dimension' : 'dimension');
// // //     //     return (
// // //     //       <Form.Item name={[record.key, 'semantic_type_role']} noStyle>
// // //     //         <Select
// // //     //           style={{
// // //     //             width: '100%',
// // //     //             backgroundColor: getOptionColor('semantic_type_role', currentValue),
// // //     //           }}
// // //     //           defaultValue={currentValue}
// // //     //           onChange={(value) => {
// // //     //             const currentValues = form.getFieldValue(record.key) || {};
// // //     //             const isNumeric = currentValues.type === 'numeric';
// // //     //             const isTimestamp = currentValues.type === 'timestamp with time zone';
// // //     //             const newValues = {
// // //     //               [record.key]: {
// // //     //                 ...currentValues,
// // //     //                 semantic_type_role: value,
// // //     //                 semantic_type_sub_type: value === 'measure' ? 'quantitative' : (isTimestamp ? 'temporal' : 'nominal'),
// // //     //                 semantic_type_default_aggregation: value === 'measure' ? 'sum' : 'count',
// // //     //                 order: '',
// // //     //               },
// // //     //             };
// // //     //             form.setFieldsValue(newValues);
// // //     //             setFormValues(prev => ({ ...prev, ...newValues }));
// // //     //           }}
// // //     //         >
// // //     //           {fieldOptions.semantic_type_role_options.map(option => (
// // //     //             <Option key={option.value} value={option.value} style={{ backgroundColor: option.color }}>
// // //     //               {option.value}
// // //     //             </Option>
// // //     //           ))}
// // //     //         </Select>
// // //     //       </Form.Item>
// // //     //     );
// // //     //   },
// // //     // },
// // //     {
// // //       title: 'Semantic Type Sub Type',
// // //       dataIndex: ['semantic_type_sub_type'],
// // //       key: 'semantic_type_sub_type',
// // //       render: (_: any, record: Column) => {
// // //         const role = formValues[record.key]?.semantic_type_role ||
// // //           metadata?.find(item => item.key === record.key)?.semantic_type?.role ||
// // //           (record.type === 'numeric' ? 'measure' : record.type === 'timestamp with time zone' ? 'dimension' : 'dimension');
// // //         const currentValue = formValues[record.key]?.semantic_type_sub_type ||
// // //           metadata?.find(item => item.key === record.key)?.semantic_type?.sub_type ||
// // //           (record.type === 'numeric' ? 'quantitative' : record.type === 'timestamp with time zone' ? 'temporal' : 'nominal');
// // //         const subTypeOptions = role === 'measure' ? fieldOptions.semantic_type_sub_type_options.filter(opt => opt.value === 'quantitative') : fieldOptions.semantic_type_sub_type_options;
// // //         return (
// // //           <Form.Item name={[record.key, 'semantic_type_sub_type']} noStyle>
// // //             <Select
// // //               style={{
// // //                 width: '100%',
// // //                 backgroundColor: getOptionColor('semantic_type_sub_type', currentValue),
// // //               }}
// // //               defaultValue={currentValue}
// // //               onChange={(value) => {
// // //                 const currentValues = form.getFieldValue(record.key) || {};
// // //                 const newValues = {
// // //                   [record.key]: {
// // //                     ...currentValues,
// // //                     semantic_type_sub_type: value,
// // //                     semantic_type_default_aggregation: value === 'quantitative' ? 'sum' : 'count',
// // //                     order: value === 'ordinal' ? currentValues.order || '' : '',
// // //                   },
// // //                 };
// // //                 form.setFieldsValue(newValues);
// // //                 setFormValues(prev => ({ ...prev, ...newValues }));
// // //               }}
// // //             >
// // //               {subTypeOptions.map(option => (
// // //                 <Option key={option.value} value={option.value} style={{ backgroundColor: option.color }}>
// // //                   {option.value}
// // //                 </Option>
// // //               ))}
// // //             </Select>
// // //           </Form.Item>
// // //         );
// // //       },
// // //     },
// // //     {
// // //       title: 'Default Aggregation',
// // //       dataIndex: ['semantic_type_default_aggregation'],
// // //       key: 'semantic_type_default_aggregation',
// // //       render: (_: any, record: Column) => {
// // //         const currentValue = formValues[record.key]?.semantic_type_default_aggregation ||
// // //           metadata?.find(item => item.key === record.key)?.semantic_type?.default_aggregation ||
// // //           (record.type === 'numeric' ? 'sum' : 'count');
// // //         return (
// // //           <Form.Item name={[record.key, 'semantic_type_default_aggregation']} noStyle>
// // //             <Select
// // //               style={{
// // //                 width: '100%',
// // //                 backgroundColor: getOptionColor('semantic_type_default_aggregation', currentValue),
// // //               }}
// // //               defaultValue={currentValue}
// // //               onChange={(value) => {
// // //                 const currentValues = form.getFieldValue(record.key) || {};
// // //                 const newValues = {
// // //                   [record.key]: {
// // //                     ...currentValues,
// // //                     semantic_type_default_aggregation: value,
// // //                   },
// // //                 };
// // //                 form.setFieldsValue(newValues);
// // //                 setFormValues(prev => ({ ...prev, ...newValues }));
// // //               }}
// // //             >
// // //               {fieldOptions.semantic_type_default_aggregation_options.map(option => (
// // //                 <Option key={option.value} value={option.value} style={{ backgroundColor: option.color }}>
// // //                   {option.value}
// // //                 </Option>
// // //               ))}
// // //             </Select>
// // //           </Form.Item>
// // //         );
// // //       },
// // //     },
// // //     {
// // //       title: 'Is Searchable',
// // //       dataIndex: ['is_searchable'],
// // //       key: 'is_searchable',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'is_searchable']} valuePropName="checked" noStyle>
// // //           <Checkbox
// // //             defaultChecked={metadata?.find(item => item.key === record.key)?.is_searchable ?? true}
// // //             onChange={(e) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   is_searchable: e.target.checked,
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Is Displayable',
// // //       dataIndex: ['is_displayable'],
// // //       key: 'is_displayable',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'is_displayable']} valuePropName="checked" noStyle>
// // //           <Checkbox
// // //             defaultChecked={metadata?.find(item => item.key === record.key)?.is_displayable ?? true}
// // //             onChange={(e) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   is_displayable: e.target.checked,
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Order',
// // //       dataIndex: ['order'],
// // //       key: 'order',
// // //       render: (_: any, record: Column) => {
// // //         const subType = formValues[record.key]?.semantic_type_sub_type ||
// // //           metadata?.find(item => item.key === record.key)?.semantic_type?.sub_type ||
// // //           (record.type === 'numeric' ? 'quantitative' : record.type === 'timestamp with time zone' ? 'temporal' : 'nominal');
// // //         return (
// // //           <Form.Item name={[record.key, 'order']} noStyle>
// // //             <Input
// // //               placeholder="Enter order values (comma-separated)"
// // //               defaultValue={metadata?.find(item => item.key === record.key)?.semantic_type?.order?.join(', ') || ''}
// // //               disabled={subType !== 'ordinal'}
// // //               onChange={(e) => {
// // //                 const currentValues = form.getFieldValue(record.key) || {};
// // //                 const newValues = {
// // //                   [record.key]: {
// // //                     ...currentValues,
// // //                     order: e.target.value,
// // //                   },
// // //                 };
// // //                 form.setFieldsValue(newValues);
// // //                 setFormValues(prev => ({ ...prev, ...newValues }));
// // //               }}
// // //             />
// // //           </Form.Item>
// // //         );
// // //       },
// // //     },
// // //     {
// // //       title: 'Source Table',
// // //       dataIndex: ['source_table'],
// // //       key: 'source_table',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'source_table']} noStyle>
// // //           <Input
// // //             placeholder="Source Table"
// // //             defaultValue={
// // //               metadata?.find(item => item.key === record.key)?.foreign_key?.source_table ||
// // //               record?.foreign_key?.source_table ||
// // //               record?.potential_fk?.source_table ||
// // //               ''
// // //             }
// // //             onChange={(e) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   source_table: e.target.value,
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Source Column',
// // //       dataIndex: ['source_column'],
// // //       key: 'source_column',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'source_column']} noStyle>
// // //           <Input
// // //             placeholder="Source Column"
// // //             defaultValue={
// // //               metadata?.find(item => item.key === record.key)?.foreign_key?.source_column ||
// // //               record?.foreign_key?.source_column ||
// // //               record?.potential_fk?.source_column ||
// // //               ''
// // //             }
// // //             onChange={(e) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   source_column: e.target.value,
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Display Column',
// // //       dataIndex: ['display_column'],
// // //       key: 'display_column',
// // //       render: (_: any, record: Column) => (
// // //         <Form.Item name={[record.key, 'display_column']} noStyle>
// // //           <Input
// // //             placeholder="Display Column"
// // //             defaultValue={
// // //               metadata?.find(item => item.key === record.key)?.foreign_key?.display_column ||
// // //               record?.foreign_key?.display_column ||
// // //               record?.potential_fk?.display_column ||
// // //               ''
// // //             }
// // //             onChange={(e) => {
// // //               const currentValues = form.getFieldValue(record.key) || {};
// // //               const newValues = {
// // //                 [record.key]: {
// // //                   ...currentValues,
// // //                   display_column: e.target.value,
// // //                 },
// // //               };
// // //               form.setFieldsValue(newValues);
// // //               setFormValues(prev => ({ ...prev, ...newValues }));
// // //             }}
// // //           />
// // //         </Form.Item>
// // //       ),
// // //     },
// // //     {
// // //       title: 'Actions',
// // //       key: 'action',
// // //       render: (_: any, record: Column) => (
// // //         <Popconfirm
// // //           title="Are you sure you want to delete this field?"
// // //           onConfirm={() => handleDelete(record)}
// // //           okText="Yes"
// // //           cancelText="No"
// // //         >
// // //           <Button icon={<DeleteOutlined />} danger size="small" onClick={(e) => e.preventDefault()} />
// // //         </Popconfirm>
// // //       ),
// // //     },
// // //   ];

// // //   const data = columns?.map(col => {
// // //     const metadataEntry = metadata?.find(item => item.key === col.key) || {};
// // //     return {
// // //       key: col?.key,
// // //       ...col,
// // //       type: metadataEntry?.type || col?.type,
// // //       display_name: metadataEntry?.display_name || col?.display_name,
// // //       foreign_key: metadataEntry?.foreign_key || col?.foreign_key || {},
// // //       potential_fk: col?.potential_fk || {},
// // //       semantic_type: metadataEntry?.semantic_type || {
// // //         role: col.type === 'numeric' ? 'measure' : col.type === 'timestamp with time zone' ? 'dimension' : 'dimension',
// // //         sub_type: col.type === 'numeric' ? 'quantitative' : col.type === 'timestamp with time zone' ? 'temporal' : 'nominal',
// // //         default_aggregation: col.type === 'numeric' ? 'sum' : 'count',
// // //         order: [],
// // //       },
// // //       is_searchable: metadataEntry?.is_searchable ?? true,
// // //       is_displayable: metadataEntry?.is_displayable ?? true,
// // //     };
// // //   });

// // //   if (!columns || columns.length === 0) {
// // //     return (
// // //       <Card className="text-center p-6">
// // //         <h4>No columns found for this entity type.</h4>
// // //         <p>Please ensure the entity type is correct and has columns defined.</p>
// // //       </Card>
// // //     );
// // //   }

// // //   return (
// // //     <Form form={form} onFinish={onFinish} onValuesChange={handleValuesChange}>
// // //       <Table
// // //         columns={columnsDef}
// // //         dataSource={data}
// // //         pagination={false}
// // //         bordered
// // //       />
// // //       <Button type="primary" htmlType="submit" style={{ marginTop: '10px' }}>
// // //         Save
// // //       </Button>
// // //     </Form>
// // //   );
// // // };

// // // export default Metadata;



// // import React, { useState, useEffect } from 'react';
// // import { Select, Button, Form, Table, message, Input, Popconfirm, Checkbox, Card, Typography } from 'antd';
// // import { DeleteOutlined } from '@ant-design/icons';
// // import { supabase } from '@/lib/supabase'; // Adjust this path to your Supabase client

// // const { Option } = Select;
// // const { Title, Paragraph } = Typography;

// // // --- INTERFACES ---
// // interface ForeignKey {
// //   source_table?: string;
// //   source_column?: string;
// //   display_column?: string;
// // }

// // interface SemanticType {
// //   role: string;
// //   sub_type: string;
// //   default_aggregation: string;
// //   order: string[];
// // }

// // interface MetadataItem {
// //   key: string;
// //   type: string;
// //   display_name: string;
// //   foreign_key?: ForeignKey;
// //   semantic_type: SemanticType;
// //   is_searchable: boolean;
// //   is_displayable: boolean;
// // }

// // interface Column {
// //   key: string;
// //   type: string;
// //   display_name: string;
// //   foreign_key?: ForeignKey;
// //   potential_fk?: ForeignKey;
// // }

// // interface DisplayColumn extends Column {
// //   status: 'current' | 'new' | 'orphaned';
// //   semantic_type?: SemanticType;
// //   is_searchable?: boolean;
// //   is_displayable?: boolean;
// // }

// // interface MetadataProps {
// //   entityType: string;
// //   entitySchema: string;
// //   fetchConfigs: () => void;
// // }

// // // --- HELPER FUNCTIONS ---
// // const toTitleCase = (str: string) => {
// //   if (!str) return '';
// //   return str
// //     .split('_')
// //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
// //     .join(' ');
// // };

// // // --- MAIN COMPONENT ---
// // const Metadata: React.FC<MetadataProps> = ({ entityType, entitySchema, fetchConfigs }) => {
// //   const [displayColumns, setDisplayColumns] = useState<DisplayColumn[]>([]);
// //   const [loading, setLoading] = useState<boolean>(true);
// //   const [form] = Form.useForm();
// //   const [formValues, setFormValues] = useState<any>({});
// //   const [entityRecord, setEntityRecord] = useState<any>(null);

// //   const fieldOptions = {
// //     semantic_type_sub_type_options: ['quantitative', 'temporal', 'nominal', 'ordinal', 'geojson'],
// //     semantic_type_default_aggregation_options: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
// //   };

// //   useEffect(() => {
// //     async function fetchData() {
// //       if (!entityType || !entitySchema) {
// //         setDisplayColumns([]);
// //         return;
// //       }
// //       setLoading(true);

// //       try {
// //         const { data: savedEntityConfig, error: configError } = await supabase
// //         .schema ('core')  
// //         .from('entities')
// //           .select('id, metadata')
// //           .eq('entity_type', entityType)
// //           .eq('entity_schema', entitySchema)
// //           .single();

// //         if (configError && configError.code !== 'PGRST116') throw configError;

// //         const savedMetadata: MetadataItem[] = savedEntityConfig?.metadata || [];
// //         setEntityRecord(savedEntityConfig);

// //         const { data: currentSchema, error: rpcError } = await supabase.rpc('core_config_get_entity_columns', {
// //           p_tablename: entityType,
// //           p_schema_name: entitySchema,
// //         });

// //         if (rpcError) throw rpcError;

// //         const mergedColumns: DisplayColumn[] = [];
// //         const savedMetadataMap = new Map(savedMetadata.map(item => [item.key, item]));
// //         const currentSchemaMap = new Map(currentSchema.map((item: Column) => [item.key, item]));

// //         for (const col of currentSchema) {
// //           const saved = savedMetadataMap.get(col.key);
// //           if (saved) {
// //             mergedColumns.push({ ...col, ...saved, status: 'current' });
// //           } else {
// //             mergedColumns.push({ ...col, status: 'new' });
// //           }
// //         }

// //         for (const saved of savedMetadata) {
// //           if (!currentSchemaMap.has(saved.key)) {
// //             mergedColumns.push({
// //               ...saved,
// //               key: saved.key, type: saved.type, display_name: saved.display_name, status: 'orphaned',
// //             });
// //           }
// //         }

// //         setDisplayColumns(mergedColumns);

// //         const initialValues = mergedColumns.reduce((acc: any, col) => {
// //           const isNumeric = col.type === 'numeric' || col.type === 'integer' || col.type === 'bigint';
// //           const isTimestamp = col.type.includes('timestamp');
          
// //           acc[col.key] = {
// //               display_name: col.display_name || toTitleCase(col.key),
// //               type: col.type,
// //               source_table: col.foreign_key?.source_table || col.potential_fk?.source_table || '',
// //               source_column: col.foreign_key?.source_column || col.potential_fk?.source_column || '',
// //               display_column: col.foreign_key?.display_column || col.potential_fk?.display_column || '',
// //               semantic_type_sub_type: col.semantic_type?.sub_type || (isNumeric ? 'quantitative' : isTimestamp ? 'temporal' : 'nominal'),
// //               semantic_type_default_aggregation: col.semantic_type?.default_aggregation || (isNumeric ? 'sum' : 'count'),
// //               order: col.semantic_type?.order?.join(', ') || '',
// //               is_searchable: col.is_searchable ?? true,
// //               is_displayable: col.is_displayable ?? true,
// //           };
// //           return acc;
// //         }, {});

// //         form.setFieldsValue(initialValues);
// //         setFormValues(initialValues);

// //       } catch (error: any) {
// //         console.error('Error fetching data:', error.message);
// //         message.error('Failed to load data: ' + error.message);
// //       } finally {
// //         setLoading(false);
// //       }
// //     }

// //     fetchData();
// //   }, [entityType, entitySchema, form]);
  
// //   const handleValuesChange = (_: any, allValues: any) => {
// //     setFormValues(allValues);
// //   };

// //   const onFinish = async (values: any) => {
// //     try {
// //         const activeKeys = new Set(displayColumns.map(c => c.key));
// //         const metadataToSave = Object.entries(values)
// //             .filter(([key]) => activeKeys.has(key))
// //             .map(([key, field]: [string, any]) => {
// //                 const originalColumn = displayColumns.find(c => c.key === key)!;
// //                 const isNumeric = originalColumn.type === 'numeric' || originalColumn.type === 'integer';

// //                 const foreignKey: ForeignKey = {
// //                     source_table: field.source_table?.trim() || undefined,
// //                     source_column: field.source_column?.trim() || undefined,
// //                     display_column: field.display_column?.trim() || undefined,
// //                 };

// //                 return {
// //                     key,
// //                     type: field.type,
// //                     display_name: field.display_name,
// //                     foreign_key: Object.values(foreignKey).some(v => v) ? foreignKey : undefined,
// //                     semantic_type: {
// //                         role: isNumeric ? 'measure' : 'dimension',
// //                         sub_type: field.semantic_type_sub_type,
// //                         default_aggregation: field.semantic_type_default_aggregation,
// //                         order: field.semantic_type_sub_type === 'ordinal' && field.order ? field.order.split(',').map((item: string) => item.trim()).filter(Boolean) : [],
// //                     },
// //                     is_searchable: field.is_searchable,
// //                     is_displayable: field.is_displayable,
// //                 };
// //             });

// //         const upsertPayload: any = {
// //             entity_type: entityType,
// //             entity_schema: entitySchema,
// //             metadata: metadataToSave,
// //         };

// //         if (entityRecord && entityRecord.id) {
// //             upsertPayload.id = entityRecord.id;
// //         }

// //         const { error } = await supabase.from('core_entities').upsert(upsertPayload, {
// //             onConflict: 'entity_type,entity_schema',
// //         });

// //         if (error) throw error;

// //         message.success('Metadata configuration saved successfully!');
// //         fetchConfigs();
// //     } catch (error: any) {
// //         console.error('Error saving metadata:', error.message);
// //         message.error('Failed to save metadata: ' + error.message);
// //     }
// //   };

// //   const handleDelete = (keyToDelete: string) => {
// //     setDisplayColumns(prev => prev.filter(col => col.key !== keyToDelete));
// //   };

// //   const columnsDef = [
// //     { title: 'Field Name', dataIndex: 'key', key: 'key', width: 200, render: (text: string, record: DisplayColumn) => <span>{text} ({record.type})</span> },
// //     { title: 'Display Name', key: 'display_name', width: 200, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_name']} noStyle><Input /></Form.Item>) },
// //     { title: 'Semantic Sub Type', key: 'semantic_type_sub_type', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_sub_type']} noStyle><Select style={{ width: '100%' }}>{fieldOptions.semantic_type_sub_type_options.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>) },
// //     { title: 'Default Aggregation', key: 'semantic_type_default_aggregation', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_default_aggregation']} noStyle><Select style={{ width: '100%' }}>{fieldOptions.semantic_type_default_aggregation_options.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>) },
// //     { title: 'Order (for Ordinal)', key: 'order', width: 200, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'order']} noStyle><Input placeholder="a,b,c" disabled={formValues[record.key]?.semantic_type_sub_type !== 'ordinal'} /></Form.Item>) },
// //     { title: 'FK Table', key: 'source_table', width: 200, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_table']} noStyle><Input placeholder="schema.table_name" /></Form.Item>) },
// //     { title: 'FK Column', key: 'source_column', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_column']} noStyle><Input placeholder="column_name" /></Form.Item>) },
// //     { title: 'FK Display', key: 'display_column', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_column']} noStyle><Input placeholder="display_column" /></Form.Item>) },
// //     { title: 'Searchable', key: 'is_searchable', width: 100, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_searchable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
// //     { title: 'Displayable', key: 'is_displayable', width: 100, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_displayable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
// //     { title: 'Actions', key: 'action', width: 80, align: 'center', fixed: 'right', render: (_: any, record: DisplayColumn) => (<Popconfirm title="Are you sure?" onConfirm={() => handleDelete(record.key)} okText="Yes" cancelText="No"><Button icon={<DeleteOutlined />} danger size="small" /></Popconfirm>),
// //     },
// //   ];

// //   if (loading) return <div>Loading configuration...</div>;
// //   if (!entityType || !entitySchema) return <Card>Please select an entity and schema to begin.</Card>;

// //   const synchedColumns = displayColumns.filter(c => c.status === 'current');
// //   const newColumns = displayColumns.filter(c => c.status === 'new');
// //   const orphanedColumns = displayColumns.filter(c => c.status === 'orphaned');

// //   return (
// //     <Form form={form} onFinish={onFinish} onValuesChange={handleValuesChange} autoComplete="off">
// //       {synchedColumns.length > 0 && (
// //         <div style={{ marginBottom: '2rem' }}>
// //           <Title level={4}>Synched Fields ✅</Title>
// //           <Paragraph type="secondary">Fields and relationships that exist in both the database and your saved configuration.</Paragraph>
// //           <Table columns={columnsDef} dataSource={synchedColumns} pagination={false} bordered rowKey="key" scroll={{ x: 1500 }} />
// //         </div>
// //       )}

// //       {newColumns.length > 0 && (
// //         <div style={{ marginBottom: '2rem' }}>
// //           <Title level={4}>New Fields ✨</Title>
// //           <Paragraph type="secondary">New fields found in the database. Configure them to add them to your metadata.</Paragraph>
// //           <Table columns={columnsDef} dataSource={newColumns} pagination={false} bordered rowKey="key" rowClassName={() => 'row-new'} scroll={{ x: 1500 }}/>
// //         </div>
// //       )}

// //       {orphanedColumns.length > 0 && (
// //         <div style={{ marginBottom: '2rem' }}>
// //           <Title level={4}>Orphaned Fields 🗑️</Title>
// //           <Paragraph type="secondary">Fields from your saved configuration that are no longer in the database. You can remove them.</Paragraph>
// //           <Table columns={columnsDef} dataSource={orphanedColumns} pagination={false} bordered rowKey="key" rowClassName={() => 'row-orphaned'} scroll={{ x: 1500 }} />
// //         </div>
// //       )}
      
// //       {displayColumns.length === 0 && (
// //         <Card>
// //             <p>No columns were found for the entity <strong>{entitySchema}.{entityType}</strong>. This could be because the table is empty or does not exist.</p>
// //         </Card>
// //       )}

// //       {displayColumns.length > 0 && (
// //         <Button type="primary" htmlType="submit" style={{ marginTop: '10px' }}>
// //           Save Configuration
// //         </Button>
// //       )}
// //     </Form>
// //   );
// // };

// // export default Metadata;

// // /*
// //   Add the following styles to your global CSS file (e.g., App.css)
// //   to get the background colors for new and orphaned rows.
// // */
// // /*
// // .row-new .ant-table-cell {
// //   background-color: #f6ffed !important;
// // }

// // .row-orphaned .ant-table-cell {
// //   background-color: #fff1f0 !important;
// //   opacity: 0.8;
// // }
// // */


// import React, { useState, useEffect } from 'react';
// import { Select, Button, Form, Table, message, Input, Popconfirm, Checkbox, Card, Typography, Dropdown, Space } from 'antd';
// import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
// import { supabase } from '@/lib/supabase';
// import _ from 'lodash'; // Using lodash for deep object comparison

// const { Option } = Select;
// const { Title, Paragraph } = Typography;

// // --- INTERFACES ---
// interface ForeignKey {
//   source_table?: string;
//   source_column?: string;
//   display_column?: string;
// }

// interface SemanticType {
//   role: string;
//   sub_type: string;
//   default_aggregation: string;
//   order: string[];
// }

// interface MetadataItem {
//   key: string;
//   type: string;
//   display_name: string;
//   foreign_key?: ForeignKey | null;
//   semantic_type: SemanticType;
//   is_searchable: boolean;
//   is_displayable: boolean;
//   is_mandatory: boolean;
//   is_template: boolean;
// }

// interface Column {
//   key: string;
//   type: string;
//   display_name: string;
//   foreign_key?: ForeignKey;
//   potential_fk?: ForeignKey;
// }

// interface DisplayColumn extends Column {
//   status: 'current' | 'new' | 'orphaned';
//   semantic_type?: SemanticType;
//   is_searchable?: boolean;
//   is_displayable?: boolean;
//   is_mandatory: boolean;
//   is_template: boolean;
// }

// interface MetadataProps {
//   entityType: string;
//   entitySchema: string;
//   fetchConfigs: () => void;
// }

// // --- HELPER FUNCTION ---
// const toSentenceCase = (str: string) => {
//   if (!str) return '';
//   const result = str.replace(/_/g, ' ');
//   return result.charAt(0).toUpperCase() + result.slice(1);
// };

// // --- MAIN COMPONENT ---
// const Metadata: React.FC<MetadataProps> = ({ entityType, entitySchema, fetchConfigs }) => {
//   const [displayColumns, setDisplayColumns] = useState<DisplayColumn[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [form] = Form.useForm();
//   const [formValues, setFormValues] = useState<any>({});
//   const [entityRecord, setEntityRecord] = useState<any>(null);
  
//   // DEV NOTE: New state to manage which columns are visible in the tables.
//   const [visibleKeys, setVisibleKeys] = useState<string[]>([
//     'key', 'display_name', 'type', 'semantic_type_sub_type','is_mandatory','is_template',
//     'source_table', 'source_column', 'display_column', 'action','semantic_type_default_aggregation','is_searchable','is_displayable','order'
//   ]);

//   const fieldOptions = {
//     data_type_options: [
//         'bigint', 'integer', 'smallint', 'numeric', 'real', 'double precision',
//         'text', 'varchar', 'char', 'date', 'timestamp', 'timestamp with time zone',
//         'boolean', 'uuid', 'json', 'jsonb', 'array',
//     ],
//     semantic_type_sub_type_options: ['quantitative', 'temporal', 'nominal', 'ordinal', 'geojson'],
//     semantic_type_default_aggregation_options: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
//   };

//   // The useEffect and data fetching logic is the same as the previous correct version.
//   useEffect(() => {
//     async function fetchData() {
//         if (!entityType || !entitySchema) {
//             setDisplayColumns([]);
//             return;
//         }
//         setLoading(true);
//         try {
//             const { data: savedEntityConfig, error: configError } = await supabase
//                 .schema('core').from('entities').select('id, metadata').eq('entity_type', entityType).eq('entity_schema', entitySchema).single();
//             if (configError && configError.code !== 'PGRST116') throw configError;

//             const savedMetadata: MetadataItem[] = savedEntityConfig?.metadata || [];
//             setEntityRecord(savedEntityConfig);

//             const { data: currentSchema, error: rpcError } = await supabase.schema('core').rpc('core_config_get_entity_columns', {
//                 p_tablename: entityType, p_schema_name: entitySchema,
//             });
//             if (rpcError) throw rpcError;

//             const mergedColumns: DisplayColumn[] = [];
//             const savedMetadataMap = new Map(savedMetadata.map(item => [item.key, item]));
//             const currentSchemaMap = new Map(currentSchema.map((item: Column) => [item.key, item]));

//             for (const col of currentSchema) {
//                 const saved = savedMetadataMap.get(col.key);
//                 if (saved) mergedColumns.push({ ...col, ...saved, status: 'current' });
//                 else mergedColumns.push({ ...col, status: 'new' });
//             }
//             for (const saved of savedMetadata) {
//                 if (!currentSchemaMap.has(saved.key)) {
//                     mergedColumns.push({ ...saved, key: saved.key, type: saved.type, display_name: saved.display_name, status: 'orphaned' });
//                 }
//             }
//             setDisplayColumns(mergedColumns);

//             const initialValues = mergedColumns.reduce((acc: any, col) => {
//                 const hasSavedFkDecision = col.hasOwnProperty('foreign_key');
//                 const isNumeric = ['numeric', 'integer', 'bigint'].includes(col.type);
//                 const isTimestamp = col.type.includes('timestamp');
//                 acc[col.key] = {
//                     display_name: col.display_name || toSentenceCase(col.key),
//                     type: col.type,
//                     source_table: hasSavedFkDecision ? col.foreign_key?.source_table || '' : col.foreign_key?.source_table || col.potential_fk?.source_table || '',
//                     source_column: hasSavedFkDecision ? col.foreign_key?.source_column || '' : col.foreign_key?.source_column || col.potential_fk?.source_column || '',
//                     display_column: hasSavedFkDecision ? col.foreign_key?.display_column || '' : col.foreign_key?.display_column || col.potential_fk?.display_column || '',
//                     semantic_type_sub_type: col.semantic_type?.sub_type || (isNumeric ? 'quantitative' : isTimestamp ? 'temporal' : 'nominal'),
//                     semantic_type_default_aggregation: col.semantic_type?.default_aggregation || (isNumeric ? 'sum' : 'count'),
//                     order: col.semantic_type?.order?.join(', ') || '',
//                     is_searchable: col.is_searchable ?? true,
//                     is_displayable: col.is_displayable ?? true,
//                     is_mandatory: col.is_mandatory ?? true,
//                     is_template: col.is_template ?? true,
//                 };
//                 return acc;
//             }, {});
//             form.setFieldsValue(initialValues);
//             setFormValues(initialValues);
//         } catch (error: any) {
//             console.error("Error fetching data:", error);
//             message.error(`Failed to load data: ${error.message}`);
//         } finally {
//             setLoading(false);
//         }
//     }
//     fetchData();
//   }, [entityType, entitySchema, form]);

//   // The onFinish and handleDelete logic is the same as the previous correct version.
//   const onFinish = async (values: any) => {
//     try {
//         const activeKeys = new Set(displayColumns.map(c => c.key));
//         const metadataToSave = Object.entries(values)
//             .filter(([key]) => activeKeys.has(key))
//             .map(([key, field]: [string, any]) => {
//                 const originalColumn = displayColumns.find(c => c.key === key)!;
//                 const isNumeric = ['numeric', 'integer', 'bigint'].includes(originalColumn.type);
//                 const hasFkInput = field.source_table || field.source_column;
//                 
//                 // --- MODIFIED LOGIC START ---
//                 let foreignKeyObject: ForeignKey | null | undefined = undefined;

//                 if (hasFkInput) {
//                     // If FK fields are populated, create the object (allows source_table/column to be null/undefined inside the object)
//                     foreignKeyObject = {
//                         source_table: field.source_table?.trim() || undefined,
//                         source_column: field.source_column?.trim() || undefined,
//                         display_column: field.display_column?.trim() || undefined,
//                     };
//                 } else if (originalColumn.hasOwnProperty('foreign_key')) {
//                     // If no FK input is present, but the original column had a saved FK (even if null), 
//                     // we must explicitly pass null to clear the existing value in the database.
//                     // If we pass 'undefined' here, it won't overwrite an existing database value.
//                     foreignKeyObject = null;
//                 }
//                 // Otherwise (if no input AND no existing value), foreignKeyObject remains undefined, 
//                 // and is NOT included in the final object using the 'spread' syntax.
                
//                 // Construct the final object, conditionally including foreign_key
//                 const baseItem = {
//                     key,
//                     type: field.type,
//                     display_name: field.display_name,
//                     semantic_type: {
//                         role: isNumeric ? 'measure' : 'dimension',
//                         sub_type: field.semantic_type_sub_type,
//                         default_aggregation: field.semantic_type_default_aggregation,
//                         order: field.semantic_type_sub_type === 'ordinal' && field.order ? field.order.split(',').map((item: string) => item.trim()).filter(Boolean) : [],
//                     },
//                     is_searchable: field.is_searchable,
//                     is_displayable: field.is_displayable,
//                     is_mandatory: field.is_mandatory,
//                     is_template: field.is_template,
//                 };
                
//                 // Conditionally add foreign_key. The spread will skip the property if foreignKeyObject is undefined.
//                 // Note: The database expects `null` to clear a value, which is why the conditional check above is crucial.
//                 return foreignKeyObject !== undefined 
//                     ? { ...baseItem, foreign_key: foreignKeyObject } 
//                     : baseItem;

//             });
//             // --- MODIFIED LOGIC END ---

//         const upsertPayload: any = {
//             entity_type: entityType,
//             entity_schema: entitySchema,
//             metadata: metadataToSave,
//         };
//         if (entityRecord && entityRecord.id) {
//             upsertPayload.id = entityRecord.id;
//         }
//         const { error } = await supabase.schema('core').from('entities').upsert(upsertPayload, {
//             onConflict: 'entity_type,entity_schema',
//         });
//         if (error) throw error;
//         message.success('Metadata configuration saved successfully!');
//         fetchConfigs();
//     } catch (error: any) {
//         console.error("Caught raw error object:", error);
//         message.error(`Failed to save metadata: ${error.message || error.details}`);
//     }
//   };
//   const handleDelete = (keyToDelete: string) => setDisplayColumns(prev => prev.filter(col => col.key !== keyToDelete));
//   const handleValuesChange = (_: any, allValues: any) => setFormValues(allValues);

//   // DEV NOTE: This is the master list of all possible columns.
//   const allColumns = [
//     { title: 'Field Name', key: 'key', dataIndex: 'key', width: 220, fixed: 'left', render: (text: string, record: DisplayColumn) => <span>{text} <span style={{opacity: 0.7}}>({record.type})</span></span> },
//     { title: 'Display Name', key: 'display_name', width: 180, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_name']} noStyle><Input /></Form.Item>) },
//     { title: 'Data Type', key: 'type', width: 180, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'type']} noStyle><Select style={{ width: '100%' }}>{fieldOptions.data_type_options.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>) },
//     { title: 'Semantic Sub Type', key: 'semantic_type_sub_type', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_sub_type']} noStyle><Select style={{ width: '100%' }}>{fieldOptions.semantic_type_sub_type_options.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>) },
//     { title: 'Default Aggregation', key: 'semantic_type_default_aggregation', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_default_aggregation']} noStyle><Select style={{ width: '100%' }}>{fieldOptions.semantic_type_default_aggregation_options.map(o => <Option key={o} value={o}>{o}</Option>)}</Select></Form.Item>) },
//     { title: 'Searchable', key: 'is_searchable', width: 90, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_searchable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
//     { title: 'Displayable', key: 'is_displayable', width: 100, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_displayable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
//     { title: 'Mandatory', key: 'is_mandatory', width: 100, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_mandatory']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
//     { title: 'Template', key: 'is_template', width: 100, align: 'center', render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_template']} valuePropName="checked" noStyle><Checkbox /></Form.Item>) },
//     { title: 'Order', key: 'order', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'order']} noStyle><Input placeholder="a,b,c" disabled={formValues[record.key]?.semantic_type_sub_type !== 'ordinal'} /></Form.Item>) },
//     { title: 'FK Table', key: 'source_table', width: 200, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_table']} noStyle><Input placeholder="schema.table_name" /></Form.Item>) },
//     { title: 'FK Column', key: 'source_column', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_column']} noStyle><Input placeholder="column_name" /></Form.Item>) },
//     { title: 'FK Display', key: 'display_column', width: 150, render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_column']} noStyle><Input placeholder="display_column" /></Form.Item>) },
//     { title: 'Actions', key: 'action', width: 80, align: 'center', fixed: 'right', render: (_: any, record: DisplayColumn) => (<Popconfirm title="Are you sure?" onConfirm={() => handleDelete(record.key)} okText="Yes" cancelText="No"><Button icon={<DeleteOutlined />} danger size="small" /></Popconfirm>),
//     },
//   ];

//   // DEV NOTE: This is the UI for the column toggler dropdown.
//   const columnMenu = (
//     <div style={{ backgroundColor: 'white', padding: '8px', border: '1px solid #d9d9d9', borderRadius: '4px' }}>
//         <Checkbox.Group
//             style={{ display: 'flex', flexDirection: 'column' }}
//             options={allColumns.filter(c => c.key !== 'action').map(c => ({ label: c.title, value: c.key }))}
//             value={visibleKeys}
//             onChange={(keys) => setVisibleKeys([...keys, 'action'])} // Ensure 'action' is always included
//         />
//     </div>
//   );

//   if (loading) return <div>Loading configuration...</div>;
//   if (!entityType || !entitySchema) return <Card>Please select an entity and schema to begin.</Card>;

//   // DEV NOTE: Filter the master column list based on user's selection before rendering.
//   const filteredColumns = allColumns.filter(col => visibleKeys.includes(col.key));
//   const synchedColumns = displayColumns.filter(c => c.status === 'current');
//   const newColumns = displayColumns.filter(c => c.status === 'new');
//   const orphanedColumns = displayColumns.filter(c => c.status === 'orphaned');
  
//   return (
//     <Form form={form} onFinish={onFinish} onValuesChange={handleValuesChange} autoComplete="off">
//         <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
//             <Dropdown overlay={columnMenu} trigger={['click']}>
//                 <Button>
//                     <Space>Configure Columns <DownOutlined /></Space>
//                 </Button>
//             </Dropdown>
//         </div>

//         {synchedColumns.length > 0 && (
//           <div style={{ marginBottom: '2rem' }}>
//             <Title level={4}>Synched Fields ✅</Title>
//             <Paragraph type="secondary">Fields and relationships that exist in both the database and your saved configuration.</Paragraph>
//             <Table columns={filteredColumns} dataSource={synchedColumns} pagination={false} bordered rowKey="key" scroll={{ x: 1500 }} />
//           </div>
//         )}
//         {newColumns.length > 0 && (
//           <div style={{ marginBottom: '2rem' }}>
//             <Title level={4}>New Fields ✨</Title>
//             <Paragraph type="secondary">New fields found in the database. Configure them to add them to your metadata.</Paragraph>
//             <Table columns={filteredColumns} dataSource={newColumns} pagination={false} bordered rowKey="key" rowClassName={() => 'row-new'} scroll={{ x: 1500 }}/>
//           </div>
//         )}
//         {orphanedColumns.length > 0 && (
//           <div style={{ marginBottom: '2rem' }}>
//             <Title level={4}>Orphaned Fields 🗑️</Title>
//             <Paragraph type="secondary">Fields from your saved configuration that are no longer in the database. You can remove them.</Paragraph>
//             <Table columns={filteredColumns} dataSource={orphanedColumns} pagination={false} bordered rowKey="key" rowClassName={() => 'row-orphaned'} scroll={{ x: 1500 }} />
//           </div>
//         )}
//         {displayColumns.length > 0 && (
//           <Button type="primary" htmlType="submit" style={{ marginTop: '10px' }}>Save Configuration</Button>
//         )}
//     </Form>
//   );
// };

// export default Metadata;



import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Select, Button, Form, Table, message, Input, Popconfirm, Checkbox, Card, Typography, Dropdown, Space, Tag } from 'antd';
import { DeleteOutlined, DownOutlined, ApartmentOutlined } from '@ant-design/icons';
import { supabase } from '@/lib/supabase'; // Adjust path as needed
import _ from 'lodash'; 
import EntityVersionManager from './EntityVersionManager';

const { Option } = Select;
const { Title, Paragraph } = Typography;

// --- INTERFACES ---

/** Defines the structure for foreign key information */
interface ForeignKey {
  source_table?: string;
  source_column?: string;
  display_column?: string;
  reason?: string;
  confidence?: string;
}

/** Defines the structure for semantic type information */
interface SemanticType {
  role: string;
  sub_type: string;
  default_aggregation: string;
  order: string[];
  keyword: boolean; 
}

/** Defines the structure for polymorphic targets */
interface PolymorphicTarget {
  key: string;
  type: string;
  display_name: string;
  foreign_key?: ForeignKey | null;
  potential_fk?: ForeignKey;
  semantic_type: SemanticType;
  is_searchable: boolean;
  is_displayable: boolean;
  is_mandatory: boolean;
  is_template: boolean;
  is_virtual: boolean;
}

/** Defines the structure for polymorphic column */
interface Polymorphic {
  targets: PolymorphicTarget[];
  id_column: string;
  type_column: string;
}

/**
 * Defines the complete structure of a metadata item as fetched from the DB function
 * and intended to be stored in the database.
 */
interface MetadataItem {
  key: string;
  type: string;
  display_name: string;
  foreign_key?: ForeignKey | null;
  potential_fk?: ForeignKey; 
  semantic_type: SemanticType;
  polymorphic?: Polymorphic; 
  is_searchable: boolean;
  is_displayable: boolean;
  is_mandatory: boolean;
  is_template: boolean;
  is_virtual: boolean;
  format?: 'array'; 
}

/**
 * Represents a column shown in the UI table.
 */
interface DisplayColumn extends MetadataItem {
  status: 'current' | 'new' | 'orphaned';
  is_polymorphic_parent?: boolean;
  is_polymorphic_target?: boolean;
  parent_key?: string; 
  target_key?: string; 
}

/** Props for the Metadata component */
interface MetadataProps {
  entityType: string;
  entitySchema: string;
  fetchConfigs: () => void; // Callback to refresh parent component list
}

// --- HELPER FUNCTION ---
/** Converts snake_case or camelCase to Sentence case */
const toSentenceCase = (str: string) => {
  if (!str) return '';
  const parts = str.split('.');
  const lastPart = parts[parts.length - 1];
  const result = lastPart
    .replace(/_/g, ' ') 
    .replace(/([A-Z])/g, ' $1'); 
  return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
};

// --- MAIN COMPONENT ---
const Metadata: React.FC<MetadataProps> = ({ entityType, entitySchema, fetchConfigs }) => {
  // State for columns displayed in the UI tables
  const [displayColumns, setDisplayColumns] = useState<DisplayColumn[]>([]);
  // Loading state
  const [loading, setLoading] = useState<boolean>(true);
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState<any>({});
  const [entityRecord, setEntityRecord] = useState<any>(null);

  const originalMetadataRef = useRef<Map<string, MetadataItem>>(new Map());

  const [visibleKeys, setVisibleKeys] = useState<string[]>([
    'key', 'display_name', 'type', 'semantic_type_sub_type',
    'source_table', 'source_column', 'display_column', 'action',
    'semantic_type_default_aggregation','is_searchable','is_displayable','is_mandatory','is_virtual','is_template','order'
  ]);

  // --- Static Options for Select dropdowns ---
  const fieldOptions = {
    data_type_options: [
      'bigint', 'integer', 'smallint', 'numeric', 'real', 'double precision',
      'text', 'varchar', 'char', 'date', 'timestamp', 'timestamp with time zone',
      'boolean', 'uuid', 'json', 'jsonb', 'array', 'USER-DEFINED',
      'object', 'array_of_objects',
      'list_string', 'list_integer', 'list_float', 'list_uuid' 
    ],
    semantic_type_sub_type_options: ['quantitative', 'temporal', 'nominal', 'ordinal', 'geojson', 'discrete'],
    semantic_type_default_aggregation_options: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
  };

  // --- DATA FETCHING FUNCTION (MOVED OUTSIDE useEffect) ---
  /** Fetches saved entity config and current DB schema, then merges them */
  const fetchData = useCallback(async () => {
    if (!entityType || !entitySchema) {
      setDisplayColumns([]);
      originalMetadataRef.current.clear();
      return;
    }
    setLoading(true);
    originalMetadataRef.current.clear(); 

    try {
      // 1. Fetch existing saved configuration from 'core.entities' table
      const { data: savedEntityConfig, error: configError } = await supabase
        .schema('core').from('entities').select('id, metadata').eq('entity_type', entityType).eq('entity_schema', entitySchema).single();

      if (configError && configError.code !== 'PGRST116') throw configError;

      const savedMetadata: MetadataItem[] = savedEntityConfig?.metadata || [];
      setEntityRecord(savedEntityConfig); 

      // 2. Fetch the current schema information using the DB function
      const { data: currentSchemaResult, error: rpcError } = await supabase
        .schema('core') 
        .rpc('met_scan_schema_columns', { 
          p_table_name: entityType,
          p_schema_name: entitySchema,
          p_is_aggressive: true,
        });

      if (rpcError) throw rpcError;
      const currentSchema: MetadataItem[] = currentSchemaResult || [];

      const mergedColumns: DisplayColumn[] = [];
      const currentSchemaMap = new Map(currentSchema.map(item => [item.key, item]));
      
      // 3. Merge saved config with current schema
      
      // Store the *complete* fetched schema or saved metadata in the ref
      currentSchema.forEach(item => {
          const savedItem = savedMetadata.find(s => s.key === item.key);
          // Use the saved version if it exists, otherwise use the schema version
          originalMetadataRef.current.set(item.key, _.cloneDeep(savedItem || item));
      });
      
      // Handle orphaned items in savedMetadata
      savedMetadata.forEach(item => {
          if (!currentSchemaMap.has(item.key)) {
              originalMetadataRef.current.set(item.key, _.cloneDeep(item));
          }
      });


      // Process columns from current schema and merge with saved data
      for (const colSchema of currentSchema) {
        const savedItem = savedMetadata.find(item => item.key === colSchema.key);
        const baseItem: MetadataItem = savedItem 
          ? {...colSchema, ...savedItem} // Saved overrides schema
          : colSchema;
        
        const status = savedItem ? 'current' : 'new';
        
        // 3a. Add the Parent Column
        mergedColumns.push({
          ...baseItem,
          status,
          is_polymorphic_parent: !!baseItem.polymorphic,
        });

        // 3b. Extract and add Polymorphic Targets
        if (baseItem.polymorphic) {
          baseItem.polymorphic.targets.forEach(target => {
            // Create a composite key for the target row: parentKey:targetKey
            const targetRowKey = `${baseItem.key}:${target.key}`;
            
            mergedColumns.push({
              ...target, // Target contains its own metadata fields (type, FK info, display_name)
              key: targetRowKey, // Use the composite key for the row/form field
              status, 
              is_polymorphic_target: true,
              parent_key: baseItem.key,
              target_key: target.key,
              // Ensure boolean fields are explicitly set to avoid undefined
              is_searchable: target.is_searchable ?? false, 
              is_displayable: target.is_displayable ?? false,
              is_mandatory: target.is_mandatory ?? true,
              is_template: target.is_template ?? true,
              is_virtual: target.is_virtual ?? false,
            });
          });
        }
      }

      // 3c. Process columns only in saved config (Orphaned)
      for (const savedItem of savedMetadata) {
        if (!currentSchemaMap.has(savedItem.key)) {
          mergedColumns.push({
            ...savedItem, 
            status: 'orphaned',
            key: savedItem.key,
            type: savedItem.type || 'unknown',
            display_name: savedItem.display_name || savedItem.key,
          });
        }
      }
      
      setDisplayColumns(mergedColumns);

      // 4. Set initial form values based on the merged data (what user will edit)
      const initialValues = mergedColumns.reduce((acc: any, col) => {
        const key = col.key;
        
        const hasSavedFkDecision = col.hasOwnProperty('foreign_key');
        const fkToShow = hasSavedFkDecision
            ? col.foreign_key 
            : (col.foreign_key || col.potential_fk); 

        acc[key] = {
          display_name: col.display_name || toSentenceCase(col.key),
          type: col.type,
          source_table: fkToShow?.source_table || '',
          source_column: fkToShow?.source_column || '',
          display_column: fkToShow?.display_column || '',
          semantic_type_sub_type: col.semantic_type?.sub_type,
          semantic_type_default_aggregation: col.semantic_type?.default_aggregation,
          order: col.semantic_type?.order?.join(', ') || '',
          is_searchable: col.is_searchable ?? false, 
          is_displayable: col.is_displayable ?? false,
          is_mandatory: col.is_mandatory ?? false,
          is_template: col.is_template ?? false,
          is_virtual: col.is_virtual ?? false,
        };
        return acc;
      }, {});
      form.setFieldsValue(initialValues);
      setFormValues(initialValues); 

    } catch (error: any) {
      console.error("Error fetching data:", error);
      message.error(`Failed to load data: ${error.message}`);
      setDisplayColumns([]);
      originalMetadataRef.current.clear();
    } finally {
      setLoading(false);
    }
  }, [entityType, entitySchema, form]); // fetchData depends on these states/props


  // --- Data Fetching Effect ---
  // Now simply calls the defined fetchData function
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // --- Event Handlers ---

  const handleValuesChange = (_: any, allValues: any) => {
    setFormValues(allValues);
  };

  /** Handle form submission: Construct and save the metadata array via RPC */
  const onFinish = async (values: any) => {
    try {
      const metadataToSave: MetadataItem[] = [];
      const polymorphicTargetValues = new Map<string, MetadataItem[]>(); 
      
      const activeDisplayColumns = displayColumns.filter(c => c.status !== 'orphaned');
      
      // 1. Separate Form Values into Top-Level and Polymorphic Targets
      for (const col of activeDisplayColumns) {
        const formFieldValues = values[col.key];

        if (formFieldValues === undefined) continue; 

        // a. Prepare Foreign Key object
        const hasFkInput = formFieldValues.source_table?.trim() || formFieldValues.source_column?.trim();
        let fkValueToSend: ForeignKey | null = null;
        if (hasFkInput) {
            fkValueToSend = {
              source_table: formFieldValues.source_table?.trim() || undefined,
              source_column: formFieldValues.source_column?.trim() || undefined,
              display_column: formFieldValues.display_column?.trim() || undefined,
            };
        }

        // b. Get Original Item (if exists) or create a base
        const originalItem = originalMetadataRef.current.get(col.is_polymorphic_target ? col.parent_key! : col.key) || originalMetadataRef.current.get(col.key);
        const baseOriginal: Partial<MetadataItem> = originalItem || {
            key: col.is_polymorphic_target ? col.target_key! : col.key,
            type: formFieldValues.type || 'unknown',
            display_name: formFieldValues.display_name || col.key,
            semantic_type: { role: 'dimension', sub_type: 'nominal', default_aggregation: 'count', order: [], keyword: false },
            is_searchable: false, is_displayable: true, is_mandatory: true, is_template: true, is_virtual: false
        };

        const isNumeric = ['numeric', 'integer', 'bigint', 'smallint', 'real', 'double precision'].includes(formFieldValues.type || baseOriginal.type!);

        // c. Construct the Saved Item
        const savedItem: MetadataItem = {
          ...(_.omit(baseOriginal, ['potential_fk', 'polymorphic']) as MetadataItem),
          key: col.is_polymorphic_target ? col.target_key! : col.key, // Use target key for targets, main key for others
          type: formFieldValues.type,
          display_name: formFieldValues.display_name,
          semantic_type: {
            ...(baseOriginal.semantic_type || {} as SemanticType),
            role: isNumeric ? 'measure' : 'dimension',
            sub_type: formFieldValues.semantic_type_sub_type,
            default_aggregation: formFieldValues.semantic_type_default_aggregation,
            order: formFieldValues.semantic_type_sub_type === 'ordinal' && formFieldValues.order
              ? formFieldValues.order.split(',').map((item: string) => item.trim()).filter(Boolean)
              : (baseOriginal.semantic_type?.order || []),
            keyword: baseOriginal.semantic_type?.keyword || false,
          },
          is_searchable: formFieldValues.is_searchable,
          is_displayable: formFieldValues.is_displayable,
          is_mandatory: formFieldValues.is_mandatory,
          is_template: formFieldValues.is_template,
          is_virtual: formFieldValues.is_virtual, 
        };

        if (fkValueToSend) {
            savedItem.foreign_key = fkValueToSend;
        } else if (col.foreign_key === null || hasFkInput === false) { 
            savedItem.foreign_key = null;
        } else {
            delete savedItem.foreign_key;
        }

        // d. Group or Store the Item
        if (col.is_polymorphic_target) {
            const parentKey = col.parent_key!;
            if (!polymorphicTargetValues.has(parentKey)) {
                polymorphicTargetValues.set(parentKey, []);
            }
            polymorphicTargetValues.get(parentKey)!.push(savedItem);
        } else {
            metadataToSave.push(savedItem);
        }
      }

      // 2. Reconstruct Polymorphic Structure
      for (const item of metadataToSave) {
          const originalParent = originalMetadataRef.current.get(item.key);
          const targets = polymorphicTargetValues.get(item.key);

          if (originalParent?.polymorphic && targets) {
              item.polymorphic = {
                  ...originalParent.polymorphic, // Preserve id_column and type_column
                  targets: targets as PolymorphicTarget[] // Add the saved targets
              };
          }
      }

      // --- 3. Execute Save RPC ---
      const { data: savedData, error: saveError } = await supabase
        .schema('core').rpc('met_save_schema_draft', {
          p_entity_schema: entitySchema,
          p_entity_type: entityType,
          p_metadata: metadataToSave,
          p_skip_merge: true 
        });
        
      if (saveError) throw saveError;
      
      message.success('Metadata configuration saved successfully! (Draft Version)');
      
      // --- 4. Update State & Refs ---
      
      // FIX: Call the now-accessible fetchData function
      await fetchData(); 
      fetchConfigs(); 

    } catch (error: any) {
      console.error("Error saving metadata:", error);
      message.error(`Failed to save metadata: ${error.message || error.details}`);
    }
  };

  /** Handle deleting a column from the UI configuration */
  const handleDelete = (keyToDelete: string) => {
    const columnToDelete = displayColumns.find(col => col.key === keyToDelete);

    const keysToRemove = new Set<string>();
    
    if (columnToDelete?.is_polymorphic_parent) {
        keysToRemove.add(keyToDelete);
        displayColumns
          .filter(c => c.parent_key === keyToDelete)
          .forEach(c => keysToRemove.add(c.key));
    } else if (columnToDelete) {
        keysToRemove.add(keyToDelete);
    }
    
    if (keysToRemove.size === 0) return;

    // Remove from the UI display list
    setDisplayColumns(prev => prev.filter(col => !keysToRemove.has(col.key)));

    // Update form state
    const newValues = { ...formValues };
    keysToRemove.forEach(key => delete newValues[key]);
    form.setFieldsValue(newValues);
    setFormValues(newValues); 

    // Remove from ref
    if (!columnToDelete?.is_polymorphic_target) {
        originalMetadataRef.current.delete(keyToDelete);
    }

    message.info(`Field(s) removed from configuration. Save to persist changes.`);
  };


  // --- Column Definitions for AntD Table ---
  const allColumnsDef = [
    // Key and Type (Fixed Left)
    { title: 'Field Name (Type)', key: 'key', dataIndex: 'key', width: 250, fixed: 'left',
      render: (text: string, record: DisplayColumn) => {
        let display = (
          <span title={record.type}>
            {record.is_polymorphic_target && <Tag icon={<ApartmentOutlined />} color="blue">Target</Tag>}
            {text.split(':').pop()} <span style={{ opacity: 0.6 }}>({record.type})</span>
          </span>
        );
        if (record.is_polymorphic_target) {
            display = <div style={{ paddingLeft: '20px', fontStyle: 'italic' }}>{display}</div>;
        }
        return display;
      }
    },
    // Editable Fields (from Form Items)
    { title: 'Display Name', key: 'display_name', width: 180,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_name']} noStyle><Input /></Form.Item>)
    },
    { title: 'Data Type', key: 'type', width: 180,
      render: (_: any, record: DisplayColumn) => {
          const isDisabled = record.is_polymorphic_target === true;
          return (
              <Form.Item name={[record.key, 'type']} noStyle>
                  <Select style={{ width: '100%' }} options={fieldOptions.data_type_options.map(o => ({label: o, value: o}))} disabled={isDisabled} />
              </Form.Item>
          );
      }
    },
    { title: 'Sub Type', key: 'semantic_type_sub_type', width: 130,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_sub_type']} noStyle><Select style={{ width: '100%' }} options={fieldOptions.semantic_type_sub_type_options.map(o => ({label: o, value: o}))} /></Form.Item>)
    },
    { title: 'Aggregation', key: 'semantic_type_default_aggregation', width: 130,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'semantic_type_default_aggregation']} noStyle><Select style={{ width: '100%' }} options={fieldOptions.semantic_type_default_aggregation_options.map(o => ({label: o, value: o}))} /></Form.Item>)
    },
    { title: 'Searchable', key: 'is_searchable', width: 90, align: 'center',
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_searchable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>)
    },
    { title: 'Displayable', key: 'is_displayable', width: 100, align: 'center',
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_displayable']} valuePropName="checked" noStyle><Checkbox /></Form.Item>)
    },
    { title: 'Mandatory', key: 'is_mandatory', width: 100, align: 'center',
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_mandatory']} valuePropName="checked" noStyle><Checkbox /></Form.Item>)
    },
    { title: 'Virtual', key: 'is_virtual', width: 90, align: 'center',
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_virtual']} valuePropName="checked" noStyle><Checkbox /></Form.Item>)
    },
    { title: 'Template', key: 'is_template', width: 90, align: 'center',
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'is_template']} valuePropName="checked" noStyle><Checkbox /></Form.Item>)
    },
    { title: 'Order', key: 'order', width: 150,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'order']} noStyle><Input placeholder="a,b,c" disabled={formValues[record.key]?.semantic_type_sub_type !== 'ordinal'} /></Form.Item>)
    },
    { title: 'FK Table', key: 'source_table', width: 200,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_table']} noStyle><Input placeholder="schema.table_name" /></Form.Item>)
    },
    { title: 'FK Column', key: 'source_column', width: 150,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'source_column']} noStyle><Input placeholder="column_name" /></Form.Item>)
    },
    { title: 'FK Display', key: 'display_column', width: 150,
      render: (_: any, record: DisplayColumn) => (<Form.Item name={[record.key, 'display_column']} noStyle><Input placeholder="display_column" /></Form.Item>)
    },
    // Action Column (Fixed Right)
    { title: 'Actions', key: 'action', width: 80, align: 'center', fixed: 'right',
      render: (_: any, record: DisplayColumn) => (
        <Popconfirm title={`Remove ${record.is_polymorphic_parent ? 'field and its targets' : 'field'} from config?`} onConfirm={() => handleDelete(record.key)} okText="Yes" cancelText="No">
          <Button icon={<DeleteOutlined />} danger size="small" />
        </Popconfirm>
      ),
    },
  ];

  // --- Column Visibility Dropdown Menu ---
  const columnMenu = (
    <div style={{ backgroundColor: 'white', padding: '10px', border: '1px solid #d9d9d9', borderRadius: '4px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)', maxHeight: '400px', overflowY: 'auto' }}>
      <Paragraph strong style={{ marginBottom: '8px' }}>Show/Hide Columns:</Paragraph>
      <Checkbox.Group
        style={{ display: 'flex', flexDirection: 'column' }}
        options={allColumnsDef
            .filter(c => !['key', 'action'].includes(c.key))
            .map(c => ({ label: c.title || c.key, value: c.key }))}
        value={visibleKeys.filter(k => k !== 'key' && k !== 'action')} 
        onChange={(keys) => setVisibleKeys(['key', ...keys, 'action'])}
      />
    </div>
  );

  // --- Scroll and Sticky Configuration ---
  const scrollConfig = { 
    x: 1500, // Horizontal scroll
    y: 'calc(100vh - 400px)', // Vertical scroll max height (adjust 400px as needed)
  };

  const stickyConfig = {
    offsetHeader: 0, // Sticks header to the top of the viewport
  };

  // --- Render Logic ---
  if (loading) return <div>Loading configuration...</div>;
  if (!entityType || !entitySchema) return <Card>Please select an entity and schema to begin.</Card>;

  const filteredColumnsDef = allColumnsDef.filter(colDef => visibleKeys.includes(colDef.key));

  const synchedColumns = displayColumns.filter(c => c.status === 'current');
  const newColumns = displayColumns.filter(c => c.status === 'new');
  const orphanedColumns = displayColumns.filter(c => c.status === 'orphaned');

  return (
    <Form form={form} onFinish={onFinish} onValuesChange={handleValuesChange} autoComplete="off">
    <EntityVersionManager 
        entity_schema={entitySchema} 
        entity_type={entityType} 
      />
        {/* Column Visibility Dropdown Button */}
        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'flex-end' }}>
            <Dropdown overlay={columnMenu} trigger={['click']}>
                <Button>
                    <Space>Configure Columns <DownOutlined /></Space>
                </Button>
            </Dropdown>
        </div>

      {/* Synched Fields Table */}
      {synchedColumns.length > 0 && (
        <div style={{ marginBottom: '2rem' }}>
          <Title level={4}>Synched Fields ✅</Title>
          <Paragraph type="secondary">Fields existing in both the database and saved configuration (including polymorphic targets).</Paragraph>
          <Table 
            columns={filteredColumnsDef} 
            dataSource={synchedColumns} 
            pagination={false} 
            bordered 
            rowKey="key" 
            scroll={scrollConfig}
            sticky={stickyConfig}
            size="small" 
          />
        </div>
      )}

      {/* New Fields Table */}
      {newColumns.length > 0 && (
        <div style={{ marginBottom: '2rem' }}>
          <Title level={4}>New Fields ✨</Title>
          <Paragraph type="secondary">New fields found in the database. Configure to add them.</Paragraph>
          <Table 
            columns={filteredColumnsDef} 
            dataSource={newColumns} 
            pagination={false} 
            bordered 
            rowKey="key" 
            rowClassName={() => 'row-new'} 
            scroll={scrollConfig}
            sticky={stickyConfig}
            size="small"
          />
        </div>
      )}

      {/* Orphaned Fields Table */}
      {orphanedColumns.length > 0 && (
        <div style={{ marginBottom: '2rem' }}>
          <Title level={4}>Orphaned Fields 🗑️</Title>
          <Paragraph type="secondary">Fields from saved configuration no longer in the database. You can remove them if desired.</Paragraph>
          <Table 
            columns={filteredColumnsDef} 
            dataSource={orphanedColumns} 
            pagination={false} 
            bordered 
            rowKey="key" 
            rowClassName={() => 'row-orphaned'} 
            scroll={scrollConfig} 
            sticky={stickyConfig}
            size="small" 
          />
        </div>
      )}

      {/* No Columns Message */}
      {displayColumns.length === 0 && !loading && ( 
        <Card>
            <p>No columns were found for the entity <strong>{entitySchema}.{entityType}</strong>. This could be due to permissions, the table/view being empty, or it not existing.</p>
        </Card>
      )}

      {/* Save Button */}
      {displayColumns.length > 0 && (
        <Button type="primary" htmlType="submit" style={{ marginTop: '10px' }}>Save Configuration</Button>
      )}
    </Form>
  );
};

export default Metadata;